<template>
  <div>
    <div class="other-banner">
      <div class="w-default center">
        <ul class="crumb">
          <li>首页</li>
          <li>智慧校园解决方案</li>
        </ul>
        <h1>智慧校园解决方案</h1>
      </div>
    </div>
    <div class="introduction-row">
      <div class="w-default d-flex flex-colum ai-center">
        <h2>智慧校园解决方案</h2>
        <p>智慧校园为广大师生提供一个全面的智能感知环境和综合信息服务平台，提供基于角色的个性化定制服务。将基于计算机网络的信息服务融入学校的各个应用与服务领域，实现互联和协作。通过智能感知环境和综合信息服务平台，为学校与外部世界提供一个相互交流和相互感知的接口。</p>
        <!-- <button></button> -->
      </div>
    </div>
    <div class="article-row w-default" id="article">
      <aside>
        <ul class="items-1">
          <li :class="[isActive1==1?'active':'','show']">
            <h2 @click="show($event)">教育类应用</h2>
            <ul class="items-2">
              <li :class="[isActive2=='1-1'?'active':'']" @click.stop="active('1-1')">安信四点半课程管理系统</li>
              <li :class="[isActive2=='1-2'?'active':'']" @click.stop="active('1-2')">安信社团课管理系统</li>
              <li :class="[isActive2=='1-3'?'active':'']" @click.stop="active('1-3')">安信校园资源管理平台</li>
              <li :class="[isActive2=='1-4'?'active':'']" @click.stop="active('1-4')">安信校园驾驶舱</li>
              <li :class="[isActive2=='1-5'?'active':'']" @click.stop="active('1-5')">安信大数据平台</li>
            </ul>
          </li>
        </ul>
      </aside>
      <article v-show="isActive2=='1-1'">
        <h1 class="mb-30">安信四点半课程管理系统</h1>
        <p
          class="mb-40"
        >系统专注于四点半课程（活动课、拓展课）管理，为学校提供多样的文化展示、便捷的自主选课，全过程的课程管理等功能，致力于帮助学校更加科学、高效的管理四点半课程，提高学生综合素质。</p>
        <!-- <img class="mb-60" src="../assets/img/SolutionEducation/eg-1.jpg" alt /> -->
        <img class="mb-60" src="../assets/img/SolutionEducation/eg-2.png" alt />
        <h2 class="mb-20">系统特色</h2>
        <h3>1）智能选课</h3>
        <P>支持复杂的选课规则设置；支持2000人并发选课，选课过程流畅、易用；支持选课时间自动定时开关；支持选课开始倒计时；支持未选课人员按照学校设定的规则自动排课。</P>
        <h3>2）展示窗口</h3>
        <P>支持为学校定制特色UI，让家长和学生更加清楚了解学校的课程设置和课程内容，让家长实时了解学生上课情况，同时系统也是学校对外展示特色的一个窗口。</P>
        <h3>3）课程管理</h3>
        <P>支持通过手机及移动终端便捷的上传图片和视频，实时记录学生精彩活动瞬间，支持课程计划、记录、总结、评价等功能，为学校提供更好的管理工具。</P>
        <h3>4）人性化设置</h3>
        <P>支持学生选课填写多个志愿，支持抢课方式，既保证公平公正，也让每个学生尽可能选到自己心仪的课程。</P>
      </article>
      <article v-show="isActive2=='1-2'">
        <h1 class="mb-30">安信社团课管理系统</h1>
        <p
          class="mb-40"
        >安信社团课管理系统是安信软件有限公司自主研发的社团课（社团课、拓展课、四点半课程）管理产品，专注于活动课程的管理。致力于帮助学校更加科学、高效的管理社团课程，同时实现学生社团的的自我管理、自我监督、自我发展，通过多层面组织引导学生社团，进行能力培养，提高学生思想觉悟，增强学生的综合素质。</p>
        <!-- <img class="mb-60" src="../assets/img/SolutionEducation/eg-1.jpg" alt /> -->
        <img class="mb-60" src="../assets/img/SolutionEducation/eg-3.png" alt />
        <h2 class="mb-20">系统特色</h2>
        <h3>1）智能选课</h3>
        <P>支持复杂的选课规则设置；支持2000人并发选课，选课过程流畅、易用；支持选课时间自动定时开关；支持选课开始倒计时；支持未选课人员按照学校设定的规则自动排课。</P>
        <h3>2）展示窗口</h3>
        <P>支持为学校定制特色UI，让家长和学生更加清楚了解学校的课程设置和课程内容，让家长实时了解学生上课情况，同时系统也是学校对外展示特色的一个窗口。</P>
        <h3>3）课程管理</h3>
        <P>支持通过手机及移动终端便捷的上传图片和视频，实时记录学生精彩活动瞬间，支持课程计划、记录、总结、评价等功能，为学校提供更好的管理工具。</P>
        <h3>4）社团管理</h3>
        <P>为学生提供社团管理、社团互动、活动组织等功能，提升学生自我管理、自我监督、自我发展能力。</P>
      </article>
      <article v-show="isActive2=='1-3'">
        <h1 class="mb-30">安信校园资源管理平台</h1>
        <p
          class="mb-40"
        >产品致力于帮助学校搭建自己的校园资源管理平台，提供资源存储、资源管理、资源分享、资源在线利用、协作办公、个人云盘、部门云盘、资源库等功能，帮助学校建设自己的校本资源库，建立校本资源共享共建机制，高效管理校本资源，随时随地便捷应用教育资源。</p>
        <!-- <img class="mb-60" src="../assets/img/SolutionEducation/eg-1.jpg" alt /> -->
        <img class="mb-60" src="../assets/img/SolutionEducation/eg-4.png" alt />
        <h2 class="mb-20">系统特色</h2>
        <h3>1）操作简单</h3>
        <P>像操作windows一样管理文件，用户使用起来熟悉而流畅，支持框选、拖拽、快捷键、右键菜单等功能，非常易用。</P>
        <h3>2）便捷利用</h3>
        <P>只要有浏览器，用户可随时随地使用资源，比如教师可随时随地打开课件授课，分享资料给学生，随时随地备课、查阅资料、协同编辑。</P>
        <h3>3）私有空间</h3>
        <P>灵活安全的权限机制，帮助学校设置公共空间、部门空间、群组空间、个人空间等，师生在智能明确的分类下利用资源。</P>
        <h3>4）资源利用</h3>
        <P>系统采用B/S架构，部署要求简单，学校限制的电脑、服务器可以利用起来，支持和校园现有系统集成同步。</P>
      </article>
      <article v-show="isActive2=='1-4'">
        <h1 class="mb-30">安信校园驾驶舱</h1>
        <p
          class="mb-40"
        >产品致力于融合校园数据进行分析展示，提供学生群体画像、教职工画像、资源情况分析、图书情况分析、考试成绩分析、安防情况分析、综合校情分析、自定义分析等功能，同时系统提供面向业务人员的自助式数据探索、可视化接入数据源、自助式可视化分析工具等功能，旨在以自助式数据探索与可视化分析方式，帮助学校洞悉数据背后隐藏的价值，让决策更“有据可依”！</p>
        <!-- <img class="mb-60" src="../assets/img/SolutionEducation/eg-1.jpg" alt /> -->
        <img class="mb-60" src="../assets/img/SolutionEducation/eg-5.png" alt />
        <h2 class="mb-20">系统特色</h2>
        <h3>1）丰富的内置看板</h3>
        <P>系统内置丰富的校情专题展示看板，通过简单的数据源配置即可直接使用，包含学生群体画像、教职工群体画像、校园资源分析、校园图书馆分析、教学成果分析、考试成绩分析、校园安防分析、综合校情展示。</P>
        <h3>2）自助式探索工具</h3>
        <P>系统提供自助式BI工具，工具简单、自助、便捷，支持图标、仪表盘的自助分析定义，可视化组件丰富且支持定制，定制出的界面美观酷炫，支持分析页面敏捷变更。</P>
      </article>
      <article v-show="isActive2=='1-5'">
        <h1 class="mb-30">安信大数据平台</h1>
        <p class="mb-40">产品致力于通过大数据技术应用，帮助学校解决结构化、半结构化和非结构化数据的集成、存储、分析及应用，简化学校大数据管理工作，发挥数据应有的价值。</p>
        <!-- <img class="mb-60" src="../assets/img/SolutionEducation/eg-1.jpg" alt /> -->
        <img class="mb-60" src="../assets/img/SolutionEducation/eg-6.png" alt />
        <h2 class="mb-20">系统特色</h2>
        <h3>1）采集及存储</h3>
        <P>支持多种的采集方式，支持非结构数据批量导入自动生成相应的结构化数据。包含分布式文件系统、分布式数据库、关系型数据库、数据调度、分布式计算、数据采集、数据交换、数据转换、数据质量等功能，对海量数据做到便捷、安全存储。</P>
        <h3>2）智能识别</h3>
        <P>对无序纷乱的文件、图片、视频等资源，系统自动识别、分类、标注、监理索引。包含图片智能分类、内容分类、不同维度分类；图片相关性评估，情感倾向评估、搜索内容评估等；图片内容提取、文本内容提取、语音转文字、文章概要生成等功能。</P>
        <h3>3）智能检索</h3>
        <P>支持全文检索、精确检索、语音检索、语义检索、图片检索、媒体检索等功能，系统具有实时高效、关系自动探索、自然语言分析等特点，支持集群管理，查询结果支持丰富的排序策略。</P>
        <h3>2）智能分析</h3>
        <P>系统内置教育行业分析模型，内置个性化行为分析、综合校情分析等多个校园大数据分析场景，按照要求配置相应的数据源建立可马上使用。</P>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive1: 1,
      isActive2: "1-1"
    };
  },
  methods: {
    show(event) {
      let el = event.currentTarget.parentNode;
      console.log(el);
      let flag = (" " + el.className + " ").indexOf(" " + "show" + " ") > -1;
      if (flag) {
        el.classList.remove("show");
      } else {
        el.classList.add("show");
      }
    },
    active(page) {
      this.isActive1 = page.split("-")[0];
      this.isActive2 = page;
      document.getElementById("article").scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.other-banner {
  background: url("@/../../assets/img/solution/xy.jpg");
}
article {
  * {
    font-size: 16px;
  }
  flex: 1;
  .m-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .mb-60 {
    margin-bottom: 60px;
  }
  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
  }
  h1 {
    font-size: 24px;
    border-left: 4px solid map-get($colors, "primary");
    padding-left: 14px;
    font-weight: bold;
  }
  h2 {
    line-height: 2;
  }
  h3 {
    line-height: 2;
  }
  p {
    line-height: 2;
  }
}
.other-banner .center ul.crumb li:last-child {
  color: #ffffff;
}
</style>
